import { render, staticRenderFns } from "./SpecialistManage.vue?vue&type=template&id=bc480df0&scoped=true"
import script from "./SpecialistManage.vue?vue&type=script&lang=js"
export * from "./SpecialistManage.vue?vue&type=script&lang=js"
import style0 from "./SpecialistManage.vue?vue&type=style&index=0&id=bc480df0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc480df0",
  null
  
)

export default component.exports